import React from 'react';
import { Title, TextInput, SelectInput, Btn, ScriptTagComponent } from 'components/';
import { connect } from 'react-redux';
import { history } from '/store';
import { withRouter } from 'react-router-dom';
import { StyledGeniusSection } from './GeniusSection.styled';
import { withTranslation } from 'react-i18next';
import { tt, tlink } from '../../../utils/translationHelper';
import queryString from 'query-string';
import * as yup from 'yup';
import { payBooking, payInfraction } from 'services/api';
import { BookingStatus } from '../../../utils/constants';
import { Typography } from '@material-ui/core';

import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';

import {
  is_gtag_enabled,
  gtag_checkout_process,
  gtag_checkout_option,
  gtag_purchase,
} from '../../../utils/googleTagsHelper';
import BasePaymentSection from '../basePaymentComponent/BasePaymentSection';
import PartialPayWarning from '../partialPayWarning';

var CreditCardValidator = require('card-validator');

class GeniusSection extends BasePaymentSection {
  constructor(props) {
    const { t, withBillingInformation } = props;
    super(props);
    this.state = {
      paymentInfo: {
        price: 0,
        bookingId: '0',
        qsamount: 0,
        infractionId: '0',
        customerId: '0',
        act: '',
        branchOfficeId: 0,
        promotionId: '',
        showBillingInfo: withBillingInformation !== undefined ? withBillingInformation : false,
        fiscalConditionId: null,
        currencyCode: '',
        exchangeRate: 1,
      },
      formErrors: {
        cardholderName: '',
        cardNumber: '',
        year: '',
        month: '',
        secCode: '',
      },
      cardIcon: 'far fa-credit-card',
      formLoading: false,
    };

    yup.addMethod(yup.number, 'isValidCreditCard', function(creditCardNumber) {
      return this.test('test-cc-number', t('cc_rejected_bad_filled_card_number'), function(
        ccNumber,
      ) {
        return CreditCardValidator.number(ccNumber).isValid;
      });
    });

    yup.addMethod(yup.number, 'isValidSecCode', function(secCode) {
      return this.test('test-cc-number', t('cc_rejected_bad_filled_security_code'), function(
        secCode,
      ) {
        const ccObject = CreditCardValidator.number(this.parent.cardNumber);
        if (!secCode || !ccObject.card) return false;

        if (ccObject.card.code.size == 4) return secCode >= 1 && secCode <= 9999;
        if (ccObject.card.code.size == 3) return secCode >= 1 && secCode <= 999;

        return secCode.toString().length === ccObject.card.code.size;
      });
    });

    this.paymentInfoFormSchema = yup.object().shape({
      cardholderName: yup.string().required(t('inputIsRequired', { field: t('titular') })),
      cardNumber: yup
        .number()
        .isValidCreditCard()
        .required(t('inputIsRequired', { field: t('numeroTarjeta') })),
      year: yup.number().required(t('inputIsRequired', { field: t('año') })),
      month: yup.number().required(t('inputIsRequired', { field: t('mes') })),
      secCode: yup
        .number()
        .isValidSecCode()
        .required(t('inputIsRequired', { field: t('codigo') })),
    });

    this.formRef = React.createRef(null);
    const year = new Date().getFullYear();
    this.years = Array.from(new Array(15), (val, index) => index + year);
    this.months = Array.from(new Array(12), (val, index) => index + 1);
  }

  componentWillMount() {
    const { location } = this.props;
    const { paymentInfo } = this.state;
    const parseQs = queryString.parse(location.search);

    if (parseQs.amount) {
      try {
        let partial = parseFloat(parseQs.amount);
        if (partial != 0) {
          this.setState({ paymentInfo: { ...paymentInfo, qsamount: partial } });
        }
      } catch {}
    }
  }

  async componentDidMount() {
    const {
      location,
      bookings,
      infractions,
      settings,
      settings: {
        configurations: { googleTagManager },
      },
      defaultCurrency,
    } = this.props;

    const parseQs = queryString.parse(location.search);

    if (this.isPayingBooking() && bookings.confirmation != null) {
      if (is_gtag_enabled(googleTagManager)) {
        gtag_checkout_process(
          { number: 3, option: 'Online Payment' },
          bookings.confirmation,
          settings,
        );
        gtag_checkout_option({ number: 3, option: 'Genius' });
      }

      this.setState(prevState => ({
        ...prevState,
        paymentInfo: {
          ...prevState.paymentInfo,
          price: this.getTotalToPay(),
          bookingId: bookings.confirmation.id,
          email: bookings.confirmation.customer.emailAddress,
          branchOfficeId: bookings.confirmation.deliveryPlace.branchOfficeId,
          promotionId: parseQs.promotionid || null,
          currencyCode: bookings.confirmation.currency,
          exchangeRate: 1,
          customerId: bookings.confirmation.customer.id,
        },
      }));
    }

    if (this.isPayingInfraction() && parseQs.customerid) {
      const infraction = infractions.current;
      this.setState(prevState => ({
        ...prevState,
        paymentInfo: {
          ...prevState.paymentInfo,
          price: this.getInfractionTotalToPay(),
          infractionId: infraction.id,
          act: infraction.act,
          customerId: parseQs.customerid,
          branchOfficeId: infraction.booking?.deliveryPlace?.branchOfficeId || null,
          currencyCode: infraction.booking?.currency || defaultCurrency.isoCode, // TODO: get currency in infraction object
          exchangeRate: 1,
        },
      }));
    }
  }

  getInfractionTotalToPay() {
    const { infractions } = this.props;
    const {
      paymentInfo: { qsamount },
    } = this.state;

    const infraction = infractions.current;
    if (qsamount && Math.abs(infraction.amount) >= Math.abs(qsamount)) {
      return Math.abs(qsamount);
    } else {
      return infraction.amount;
    }
  }

  handleCardholderName = cardholderName => {
    this.setState(prevState => ({
      ...prevState,
      paymentInfo: { ...prevState.paymentInfo, cardholderName },
      formErrors: { ...prevState.formErrors, cardholderName: null },
    }));
  };

  handleCardNumber = cardNumber => {
    const ccObject = CreditCardValidator.number(cardNumber);
    const ccIcon = this.getCreditCardIcon(ccObject.card ? ccObject.card.type : '');

    this.setState(prevState => ({
      ...prevState,
      paymentInfo: {
        ...prevState.paymentInfo,
        cardNumber,
        paymentMethodID: ccObject.card ? ccObject.card.type : '',
      },
      formErrors: { ...prevState.formErrors, cardNumber: null, secCode: null },
      cardIcon: ccIcon,
    }));
  };

  getCreditCardIcon = ccType => {
    let icon = '';

    switch (ccType) {
      case 'visa':
        icon = 'fab fa-cc-visa';
        break;
      case 'american-express':
        icon = 'fab fa-cc-amex';
        break;
      case 'mastercard':
        icon = 'fab fa-cc-mastercard';
        break;
      default:
        icon = 'far fa-credit-card';
        break;
    }

    return icon;
  };

  handleSecCode = secCode => {
    this.setState(prevState => ({
      ...prevState,
      paymentInfo: { ...prevState.paymentInfo, secCode },
      formErrors: { ...prevState.formErrors, secCode: null },
    }));
  };

  handleMonth = month => {
    this.setState(prevState => ({
      ...prevState,
      paymentInfo: { ...prevState.paymentInfo, month },
      formErrors: { ...prevState.formErrors, month: null },
    }));
  };

  handleYear = year => {
    this.setState(prevState => ({
      ...prevState,
      paymentInfo: { ...prevState.paymentInfo, year },
      formErrors: { ...prevState.formErrors, year: null },
    }));
  };

  handleSubmit = e => {
    e.preventDefault();
    const paymentInfo = this.state.paymentInfo;
    const { credentials } = this.props;
    this.setState({ formLoading: true });

    CayanCheckoutPlus.setWebApiKey(credentials.webApiKey);

    this.paymentInfoFormSchema
      .validate(paymentInfo, { abortEarly: false })
      .then(valid => {
        CayanCheckoutPlus.createPaymentToken({
          success: this.successCallback,
          error: this.failureCallback,
        });
      })
      .catch(err => {
        this.setState({ formLoading: false });

        if (err.inner) {
          const formErrors = err.inner.reduce((prevErrors, currentError) => {
            return {
              ...prevErrors,
              [currentError.path]: currentError.message,
            };
          }, {});
          this.setState(prevState => ({ ...prevState, formErrors }));
        } else {
          this.setState(prevState => ({
            ...prevState,
            formErrors: { ...prevState.formErrors, genericGeniusError: err.message },
          }));
        }
        window.scrollTo(0, this.formRef.current.offsetTop);
      });
  };

  successCallback = tokenResponse => {
    this.executePayment(tokenResponse.token);
  };

  failureCallback = tokenResponse => {
    if (tokenResponse && tokenResponse.length > 0) {
      const formErrors = tokenResponse.reduce((prevErrors, currentError) => {
        const key = this.matchErrorReason(currentError.reason);
        const message = this.matchErrorCode(currentError);
        return { ...prevErrors, [key]: message };
      }, {});

      return this.setState(prevState => ({ ...prevState, formErrors }));
    }
    return { ...prevErrors, genericGeniusError: 'Unhandled Error' };
  };

  matchErrorReason = currentErrorReason => {
    switch (currentErrorReason) {
      case 'cardnumber':
        return 'cardNumber';
      case 'cvv':
        return 'secCode';
      case 'expirationmonth':
        return 'month';
      case 'card_expiration_year':
        return 'year';
      case 'expirationyear':
        return 'year';
      default:
        return 'genericGeniusError';
    }
  };

  matchErrorCode = currentError => {
    switch (currentError.error_code) {
      case 'NOT_FOUND':
        return 'A required form field is missing from the page and/or could not be found.';
      case 'REQUIRED':
        return 'A required field contains an empty value.';
      case 'VALIDATION':
        return 'A field contains data that is invalid';
      case 'SERVER':
        switch (currentError.reason) {
          case 'UNEXPECTED':
            return 'An unexpected error occurred on the server and the request was not processed.';
          case 'UNAVAILABLE':
            return 'The server is currently unavailable for tokenizing payment information.';
          case 'UNAUTHORIZED':
            return 'The server rejected the Web API key supplied.';
          case 'PAYMENT_NOT_SUPPORTED':
            return 'The payment method is not supported by the merchant.';
          default:
            return 'Server error unhandled';
        }
      case 'SERVER_REQUIRED':
        return 'The server did not receive a field which is required to create a single-use token. This should not occur under normal circumstances, as all required fields are validated in the JavaScript library.';
      case 'SERVER_VALIDATION':
        return 'The server received a field which failed validation. This should not occur under normal circumstances, as all required fields are validated in the JavaScript library.';
      default:
        return 'Unhandled error';
    }
  };

  executePayment = async token => {
    const {
      t,
      i18n,
      bookings,
      settings,
      settings: {
        configurations: { googleTagManager },
      },
    } = this.props;

    let paymentParams = this.state.paymentInfo;
    paymentParams.gatewayId = 'GENIUS';
    paymentParams.orderID = this.state.paymentInfo.bookingId;
    paymentParams.token = token;

    try {
      const res = await this.makePayment(paymentParams);

      let subtitle;
      if (res.bookingId !== 0)
        subtitle = t('feedbackBoxMessages.book.successSubtitle', {
          booking_id: res.bookingId,
        });

      if (is_gtag_enabled(googleTagManager)) gtag_purchase(bookings.confirmation, settings);
      history.push(
        `${tlink('__Routes.paymentSuccess', t, i18n, null, settings.configurations.langConfig)}`,
        { subtitle },
      );
    } catch (error) {
      let errorMessage;

      if (error.response == null || error.response.data == null) {
        errorMessage = t('paymentGenericError');
      } else if (error.response.data.code === 500) {
        errorMessage = t('payBookingGatewayFailGenericError', {
          bookingId: paymentParams.bookingId,
        });
      } else if (error.response.data.code === 501) {
        errorMessage = t('payBookingRentlyFailGenericError', {
          transactionId: error.response.data.message,
        });
      }
      history.push(
        `${tlink('__Routes.paymentFailed', t, i18n, null, settings.configurations.langConfig)}`,
        { error: errorMessage },
      );
    }
  };

  makePayment = paymentInfo => {
    if (this.isPayingBooking()) return payBooking(paymentInfo);
    if (this.isPayingInfraction()) return payInfraction(paymentInfo);
  };

  showOrderIdentifier = () => {
    const { t, bookings, settings } = this.props;
    const confirmedOrderText = settings?.paymentConfiguration?.confirmedOrderText;

    if (this.isPayingBooking()) {
      const booking_id = this.state.paymentInfo.bookingId.toString().padStart(7, '0');
      const bookingStatus = bookings.confirmation.currentStatus;

      if ([BookingStatus.reserved, BookingStatus.confirmed].includes(bookingStatus)) {
        return (
          tt(confirmedOrderText, t, true, { booking_id }) || t('ordenConfirmada', { booking_id })
        );
      }
      return t('orden', { booking_id });
    }

    if (this.isPayingInfraction()) {
      if (!this.state.paymentInfo.act) return null;
      return `ACTA ${this.state.paymentInfo.act?.toString().padStart(7, '0')}`;
    }
  };

  isPayingBooking = () => {
    const { bookings, location } = this.props;
    const parseQs = queryString.parse(location.search);

    return parseQs.bookingid || (bookings && bookings.confirmation);
  };

  isPayingInfraction = () => {
    const { infractions, location } = this.props;
    const parseQs = queryString.parse(location.search);

    return parseQs.infractionid && parseQs.customerid && infractions && infractions.current;
  };

  getPayButtonText = () => {
    const { t } = this.props;

    if (this.isPayingBooking()) {
      const booking_id = this.state.paymentInfo.bookingId.toString().padStart(7, '0');
      return this.state.formLoading
        ? t('pagandoReserva', { booking_id })
        : t('pagarReserva', { booking_id });
    }

    if (this.isPayingInfraction()) {
      const act = this.state.paymentInfo.act?.toString().padStart(7, '0');
      return this.state.formLoading ? t('payingInfraction', { act }) : t('payInfraction', { act });
    }
  };

  parseToGeniusMonths = months => {
    return months.map(m => m.toString().padStart(2, '0'));
  };

  parseToGeniusYears = years => {
    return years.map(y => y.toString().substring(2));
  };

  render() {
    const { t, title, subtitle, script, credentials } = this.props;

    if (!credentials) return null;

    return (
      <StyledGeniusSection className="col-md-9">
        <div className="row col-md-6">
          <div className="col-md-12">
            <Title
              type="h2"
              text={title}
              weight="900"
              fontSize={30}
              className={`${title != null ? '' : 'd-none'}`}
            />
          </div>
          <div className="col-md-12">
            <p className={subtitle != null ? '' : 'd-none'}>{tt(subtitle, t)}</p>
          </div>
        </div>
        <div className="payment-block">
          <div className="col-md-12 p-0 LogosContainer">
            <img
              width="60"
              height="60"
              className="mr-4"
              src="/images/ssl.jpg"
              alt={t('CertificadoSSL')}
            />
            <div className="SecureLogoContainer">
              <div className="LogoContainer">
                <VerifiedUserOutlinedIcon />
              </div>
              <div>
                <Typography variant="body1" className="CompraTitle">
                  {t('CompraSegura')}
                </Typography>
                <Typography variant="body1"> {t('SafeTransactionsSite')}</Typography>
              </div>
            </div>
          </div>
          <div className="adicionales-block pb-1 pt-3 payment-code">
            <div className="col-md-12 p-0">
              <p className="mb-1">
                <strong>{this.showOrderIdentifier()}</strong>
              </p>
              <p>
                <strong>
                  {t('totalToPay')} {this.showTotalToPay()}
                </strong>
              </p>
              <hr />
              <PartialPayWarning />
            </div>
          </div>
          <div className="row adicionales-block mb-5 pt-3">
            <div className="col-md-10 form-pago">
              <form id="genius-form" onSubmit={this.handleSubmit} ref={this.formRef}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <span className="label">{t('numeroTarjeta')}</span>
                      <TextInput
                        inputClass="form-control"
                        type="number"
                        onChange={this.handleCardNumber}
                        value={this.state.paymentInfo.cardNumber}
                        error={this.state.formErrors.cardNumber}
                        icon={this.state.cardIcon}
                        options={{ name: 'formcardnumber', 'data-cayan': 'cardnumber' }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <span className="label">{t('codigo')}</span>
                      <TextInput
                        inputClass="form-control"
                        onChange={this.handleSecCode}
                        value={this.state.paymentInfo.secCode}
                        error={this.state.formErrors.secCode}
                        options={{ name: 'formcvv', 'data-cayan': 'cvv' }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <span className="label">{t('mes')}</span>
                      <SelectInput
                        inputClass="form-control"
                        type="number"
                        onChange={this.handleMonth}
                        selected={this.state.paymentInfo.month}
                        error={this.state.formErrors.month}
                        options={this.parseToGeniusMonths(this.months)}
                        props={{ name: 'formexpiremonth', 'data-cayan': 'expirationmonth' }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <span className="label">{t('año')}</span>
                      <SelectInput
                        inputClass="form-control"
                        type="number"
                        onChange={this.handleYear}
                        error={this.state.formErrors.year}
                        selected={this.state.paymentInfo.year}
                        options={this.parseToGeniusYears(this.years)}
                        props={{ name: 'formexpireyear', 'data-cayan': 'expirationyear' }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <span className="label">{t('titular')}</span>
                      <TextInput
                        inputClass="form-control"
                        onChange={this.handleCardholderName}
                        value={this.state.paymentInfo.cardholderName}
                        error={this.state.formErrors.cardholderName}
                      />
                    </div>
                  </div>
                </div>
                {this.state.formErrors.genericGeniusError && (
                  <div className="row">
                    <div className="col-md-12">
                      <p className="error">{this.state.formErrors.genericGeniusError}</p>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <Btn
                      type="submit"
                      text={this.getPayButtonText()}
                      disabled={this.state.formLoading}
                      className="mt-5 genius-pay_button"
                    />
                  </div>
                  <div className="logo-container">
                    <span>{t('providedBy')}</span>
                    <img
                      width="151"
                      height="52"
                      className="genius-logo"
                      src="/images/payments/global-img.png"
                      alt="Genius"
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="col-md-2">
              <ScriptTagComponent
                url={script}
                loadLibrary={true}
                async={true}
                scriptType="text/javascript"
              />
            </div>
          </div>
        </div>
      </StyledGeniusSection>
    );
  }
}

const mapStateToProps = ({ bookings, infractions, siteConfiguration, global }) => ({
  bookings: bookings,
  infractions: infractions,
  settings: siteConfiguration.settings,
  listDocumentTypes: global.listDocumentTypes,
  defaultCurrency: global.defaultCurrency,
});
export default connect(mapStateToProps, {})(withRouter(withTranslation()(GeniusSection)));
